<template>
  <main class="app-main">
    <div class="app-content-header">
      <div class="container-fluid">
        <div class="row">
          <div class="col-sm-6"><h3 class="mb-0">جائزة تسجيل عميل</h3></div>
          <div class="col-sm-6">
            <ol class="breadcrumb float-sm-end">
              <li class="breadcrumb-item"><router-link to="/">الرئيسية</router-link></li>
              <li class="breadcrumb-item active" aria-current="page">جائزة تسجيل عميل</li>
            </ol>
          </div>
        </div>
      </div>
    </div>

    <div class="app-content">
      <div class="container-fluid">
        <div class="card shadow card-warning card-outline mt-5">
          <div class="card-header">
            <button
              class="filter-btn w-100 text-start collapse-toggle"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#registerPrizesFilterCard"
              aria-expanded="false"
              aria-controls="registerPrizesFilterCard"
            >
              <i class="fa-solid fa-magnifying-glass"></i> بحث وتصفية
            </button>
          </div>

          <div class="collapse" id="registerPrizesFilterCard">
            <form action="" @submit.prevent="filterSubmit">
              <div class="card-body">
                <div class="row">
                  <div class="col-6 col-sm-3 mb-3">
                    <input type="text" v-model="searchName" class="form-control" placeholder="اسم العميل">
                  </div>
                  <div class="col-6 col-sm-3 mb-3">
                    <input type="text" v-model="searchMobile" class="form-control" placeholder="رقم جوال العميل">
                  </div>
                  <div class="col-6 col-sm-3 mb-3">
                    <label class="form-label">من تاريخ</label>
                    <input type="date" v-model="searchDateFrom" class="form-control">
                  </div>
                  <div class="col-6 col-sm-3 mb-3">
                    <label class="form-label">إلى تاريخ</label>
                    <input type="date" v-model="searchDateTo" class="form-control">
                  </div>
                </div>
              </div>
              <div class="card-footer">
                <div class="row">
                  <div class="col text-end">
                    <button type="submit" class="btn btn-warning btn-sm">
                      <i class="fa-solid fa-filter"></i> بحث وتصفية
                    </button>
                    <button type="button" class="btn btn-light btn-sm ms-3" @click.prevent="clearFilter">
                      <i class="fa-solid fa-filter-circle-xmark"></i> إلغاء
                    </button>
                  </div>
                </div>
              </div>
            </form>
          </div>
        </div>

        <div class="row">
          <div class="col">
            <div class="card card-secondary card-outline mb-4 mt-5">
              <div class="card-header d-flex align-items-center">
                <div class="card-title mb-0">جائزة تسجيل عميل</div>
                <span v-if="countRows > 0" class="badge rounded-pill bg-primary fs-6 px-3 py-2 ms-auto">
                  عدد النتائج ( {{ countRows }} )
                </span>
              </div>
              <errorAlert v-if="hasError" :alertMessage="message" :errorNumber="errorNumber" />
              <div class="card-body">
                <mainLoader v-if="mainLoading" />
                <div v-else class="row">
                  <div class="col">
                    <div v-if="!rows.length" class="alert alert-info">لا توجد سجلات</div>
                    <div v-else class="table-responsive">
                      <table class="table table-striped align-middle">
                        <thead>
                          <tr>
                            <th>#</th>
                            <th>اسم العميل</th>
                            <th>رقم الجوال</th>
                            <th>قيمة الجائزة</th>
                            <th>معرّف الجهاز</th>
                            <th>تاريخ الحصول على الجائزة</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr v-for="row in rows" :key="row.id">
                            <td>{{ row.id }}</td>
                            <td>{{ row.User ? row.User.name : '—' }}</td>
                            <td dir="ltr">{{ row.User ? row.User.mobile : '—' }}</td>
                            <td>{{ formatAmount(row.amount) }}</td>
                            <td dir="ltr">{{ row.deviceId || '—' }}</td>
                            <td>{{ formatDate(row.createdAt) }}</td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
              <div class="card-footer">
                <div class="row">
                  <div class="col">
                    <ul class="pagination">
                      <li v-if="currentPage > 1" class="page-item">
                        <a class="page-link" href="#" @click.prevent="prevPage">السابق</a>
                      </li>
                      <li v-for="page in pages" :key="page" class="page-item">
                        <a v-if="page === currentPage" class="page-link active" href="javascript:void(0)">{{ page }}</a>
                        <a v-else class="page-link" href="javascript:void(0)" @click="goToPage(page)">{{ page }}</a>
                      </li>
                      <li v-if="rows.length >= 30" class="page-item">
                        <a class="page-link" href="#" @click.prevent="nextPage">التالي</a>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </main>
</template>

<script>
import { formatDate } from '@/helpers/tools';

export default {
  name: 'RegisterPrizesList',
  data() {
    return {
      mainLoading: true,
      hasError: false,
      message: '',
      errorNumber: 0,
      rows: [],
      currentPage: parseInt(this.$route.query.page) || 1,
      pages: [],
      countRows: 0,
      searchName: this.$route.query.name || '',
      searchMobile: this.$route.query.mobile || '',
      searchDateFrom: this.$route.query.dateFrom || null,
      searchDateTo: this.$route.query.dateTo || null,
    };
  },
  methods: {
    formatDate,
    formatAmount(amount) {
      return `${Number(amount || 0).toFixed(2)} ر.س`;
    },
    getList() {
      this.mainLoading = true;
      this.hasError = false;

      const urlQuery = [`page=${this.currentPage}`];
      if (this.searchName.trim())
        urlQuery.push(`name=${encodeURIComponent(this.searchName.trim())}`);
      if (this.searchMobile.trim())
        urlQuery.push(`mobile=${encodeURIComponent(this.searchMobile.trim())}`);
      if (this.searchDateFrom)
        urlQuery.push(`dateFrom=${this.searchDateFrom}`);
      if (this.searchDateTo)
        urlQuery.push(`dateTo=${this.searchDateTo}`);

      this.$router.replace({
        query: {
          page: this.currentPage,
          ...(this.searchName ? { name: this.searchName } : {}),
          ...(this.searchMobile ? { mobile: this.searchMobile } : {}),
          ...(this.searchDateFrom ? { dateFrom: this.searchDateFrom } : {}),
          ...(this.searchDateTo ? { dateTo: this.searchDateTo } : {}),
        },
      }).catch(() => {});

      this.$http.get(`/api/admin/registerPrizes/list?${urlQuery.join('&')}`)
        .then(({ data }) => {
          this.rows = data.rows;
          this.pages = data.pages ?? [this.currentPage];
          this.countRows = data.countRows ?? 0;
          this.mainLoading = false;
        })
        .catch(err => {
          [this.message, this.errorNumber] = this.$globalError(err, true);
          this.hasError = true;
          this.mainLoading = false;
          window.scrollTo({ top: 0, behavior: 'smooth' });
        });
    },
    filterSubmit() {
      this.currentPage = 1;
      this.getList();
    },
    clearFilter() {
      this.currentPage = 1;
      this.searchName = '';
      this.searchMobile = '';
      this.searchDateFrom = null;
      this.searchDateTo = null;
      this.$router.replace({ query: {} }).catch(() => {});
      this.getList();
    },
    nextPage() {
      this.currentPage += 1;
      this.getList();
    },
    prevPage() {
      this.currentPage -= 1;
      this.getList();
    },
    goToPage(page) {
      this.currentPage = page;
      this.getList();
    },
  },
  created() {
    this.getList();
  },
};
</script>
